import { render, staticRenderFns } from "./SearchDirectionOlva.vue?vue&type=template&id=65d6b5d9"
import script from "./SearchDirectionOlva.vue?vue&type=script&lang=js"
export * from "./SearchDirectionOlva.vue?vue&type=script&lang=js"
import style0 from "./SearchDirectionOlva.vue?vue&type=style&index=0&id=65d6b5d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports